// extracted by mini-css-extract-plugin
export default {"address":"AddressItem_address__30bvO","addressInfo":"AddressItem_addressInfo__u1a-Y","addressLink":"AddressItem_addressLink__S88zx","activeLink":"AddressItem_activeLink__gJ3q9"};